import { putResolve, select } from 'redux-saga/effects'

import {
    PICO_API_URL,
    PURCHASE_ARTICLE,
    PURCHASE_ARTICLE_GUEST,
} from '@piconetworks/endpoints'

import { REQUEST } from '@piconetworks/network-middleware'

import logger from 'common/logger'

import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'

export default function* watchPurchaseArticle() {
    const { content } = yield select(Zoid.selectors.getXprops)

    const loader = yield select(Loader.selectors.loader)
    const scope = (loader.user) ? 'user' : 'guest'

    const { article } = loader[scope]
    try {
        yield putResolve({
            type: REQUEST,
            config: {
                method: 'post',
                baseURL: PICO_API_URL(),
                url: (scope === 'user') ? PURCHASE_ARTICLE() : PURCHASE_ARTICLE_GUEST(),
                data: {
                    // eslint-disable-next-line camelcase
                    article_id: article.id,
                    taxonomies: content.taxonomies,
                },
            },
        })
    } catch (error) {
        logger.error('Failed to purchase article', {
            scope,
            // eslint-disable-next-line camelcase
            article_id: article.id,
            taxonomies: content.taxonomies,
        })
    }
}
